import { NgModule } from '@angular/core';
import { StoreModule } from './store/store.module';
import { PAGE_LAYOUT_HANDLER, PageLayoutComponent, PageLayoutModule, SpinnerModule } from "@spartacus/storefront";
import { PageMetaResolver } from "@spartacus/core";
import { GenSearchPageMetaResolver } from '../../resolvers/search-page-meta.resolver';
import { GenCategoryPageMetaResolver } from '../../resolvers/category-page-meta.resolver';
import { BundleCarouselModule } from '../bundle-carousel/bundle-carousel.module';
import { GenLayoutHandlerService } from '../../services/layout-handler.service';
import { RouterModule } from '@angular/router';
import { GenCmsPageGuard } from '../../guards/cms-page.guard';
import { CombineArraysModule } from '../../shared/pipes/combine-arrays/combine-arrays.module';
import { GenApplicableProductsModule } from './product-tabs/applicable-products/applicable-products.module';
import { GenProductAttributesModule } from './product-tabs/product-attributes/product-attributes.module';
import { GenProductNotesModule } from './product-tabs/product-notes/product-notes.module';
import { GenProductDocumentListComponent } from './product-tabs/product-document-list/product-document-list.component';

@NgModule({
  imports: [
    StoreModule,
    SpinnerModule,
    GenProductAttributesModule,
    GenApplicableProductsModule,
    GenProductNotesModule,
    GenProductDocumentListComponent,
    CombineArraysModule,
    BundleCarouselModule,
    PageLayoutModule,
    RouterModule.forChild([
      {
        // @ts-ignore
        path: null,
        canActivate: [GenCmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'product' },
      },
    ]),
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: GenLayoutHandlerService,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: GenCategoryPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: GenSearchPageMetaResolver,
      multi: true,
    },
  ]
})
export class GenProductModule {
}
